import type {
  CouponDiscountForShoppingCart,
  MembershipDiscountForShoppingCart,
  MoneyRecord,
  UserGroupMembershipOutput
} from '@navio/nsdk';

type CheckoutDiscountRowData = {
  key: string;
  kind: 'coupon' | 'membership';
  label: string;
  amount: MoneyRecord;
  imageUrl?: string | null;
};

export const membershipProgramImages = (programs: UserGroupMembershipOutput[] | undefined) => {
  const imageByDiscountId = new Map<number, string>();
  const imageByDiscountName = new Map<string, string>();

  for (const program of programs ?? []) {
    if (!program.image) {
      continue;
    }
    for (const discount of program.discounts) {
      imageByDiscountId.set(discount.id, program.image);
      imageByDiscountName.set(discount.name, program.image);
    }
  }

  return { imageByDiscountId, imageByDiscountName };
};

export const toCheckoutDiscountRows = ({
  couponDiscounts,
  membershipDiscounts,
  imageByDiscountId
}: {
  couponDiscounts: CouponDiscountForShoppingCart[];
  membershipDiscounts: MembershipDiscountForShoppingCart[];
  imageByDiscountId?: Map<number, string>;
}): CheckoutDiscountRowData[] => [
  ...couponDiscounts.map((coupon) => ({
    key: `coupon-${coupon.id}`,
    kind: 'coupon' as const,
    label: coupon.name,
    amount: coupon.discount
  })),
  ...membershipDiscounts.map((discount, idx) => ({
    key: `membership-${discount.membershipDiscountId}-${idx}`,
    kind: 'membership' as const,
    label: discount.name,
    amount: discount.discount,
    imageUrl: imageByDiscountId?.get(discount.membershipDiscountId) ?? null
  }))
];
